//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CardSection',
  props: {
    cardClasses: {
      type: String,
      default: '',
    },
    colClasses: {
      type: String,
      default: 'col-xl-10',
    },
  },
};
